import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import AvailabilityStatus from '@bibliocommons/availability-status';
import PublicationDate from '@bibliocommons/shared-publication-date';
import FormatIcon from '@bibliocommons/format-icon';
import { Checkmark } from '@bibliocommons/base-icons';
import { availabilityShape, bibShape } from '@bibliocommons/bc-prop-types';

import FormatChooserSRMessage from '../FormatChooserSRMessage';

import './BibManifestationInfo.scss';

export default function BibManifestationInfo({
  bib,
  availability,
  showAvailability,
  showPublicationDate,
  showEdition,
  showCheckMark,
  formatsCount
}) {
  const bibFormat = bib.getIn(['briefInfo', 'format']);
  const pubDate = bib.getIn(['briefInfo', 'publicationDate']);
  const edition = bib.getIn(['briefInfo', 'edition']);

  return (
    <div className="cp-bib-manifestation-info">
      <FormatIcon format={bibFormat} />
      <div className="manifestation-overview" aria-hidden>
        <span className="bib-details">
          <FormattedMessage id={`FORMAT.${bibFormat.toLowerCase()}`} />
          {!!pubDate && showPublicationDate && <PublicationDate publicationDate={pubDate} separator=", " />}
          {!!edition && showEdition && <> &mdash; {edition}</>}
        </span>
        {showAvailability && (
          <AvailabilityStatus
            rollUpStatus={availability.get('statusType')}
            status={availability.get('localisedStatus')}
            availabilityLocationType={availability.get('availabilityLocationType')}
          />
        )}
      </div>
      <FormatChooserSRMessage
        isActive={showPublicationDate}
        bib={bib}
        formatsCount={formatsCount}
        availability={availability}
      />
      {showCheckMark && <Checkmark />}
    </div>
  );
}

BibManifestationInfo.propTypes = {
  bib: bibShape.isRequired,
  availability: availabilityShape.isRequired,
  showAvailability: PropTypes.bool,
  showPublicationDate: PropTypes.bool,
  showEdition: PropTypes.bool,
  showCheckMark: PropTypes.bool,
  formatsCount: PropTypes.number
};
